import React from 'react';
import styler from 'react-styling';
import { StyleRoot } from 'radium';

import { MeetingRoomHeader } from '../index';

const style = styler `   
  Container
    background-color: #212121
    width: 100%
    height: 100%
    top: 0
    left: 0
    position: fixed
  LinksDiv
    display: flex
    justify-content: space-around
    align-items: center
    height: 100%
  Link
    color: #f7f7f9
    font-size: 25px
`;

const MeetingRoomLanding = () => (
  <StyleRoot>
    <div style={style.Container}>
      <MeetingRoomHeader text="Pick Option" theme="dark" />
      <div style={style.LinksDiv}>
        <a href={'#/meetingrooms/locations'} style={style.Link}>Meeting room locations</a>
        <a href={'#/meetingrooms/list'} style={style.Link}>Meeting room list</a>
      </div>
    </div>
  </StyleRoot>
);

export default MeetingRoomLanding;



// WEBPACK FOOTER //
// ./src/js/Components/MeetingRooms/MeetingRoomLanding.js